import { gql } from '@apollo/client'

export const INCREMENT_VIEWS = gql`
  mutation IncrementViews($incrementViewsInput: IncrementViewsInput) {
    incrementViews(incrementViewsInput: $incrementViewsInput)
  }
`
